import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import CircleCloseIcon from '../../../../../new-components/svg-icons/CircleCloseIcon';
// import { setMapMode } from '../../../../../redux/slices/sahelSlice';
import { MapMode } from '../../../types';
import CalculateDistanceInput from '../CalculateDistanceInput';
import MDistanceResult from './MDistanceResult';
import { useTranslation } from 'next-i18next';
import { logEvent } from '../../../../../new-lib/analytics';
import { getPageLocation } from '../../../../../helpers/common';
import { useRouter } from 'next/router';
import CalculateDistanceIcon from '../../../../../new-components/svg-icons/CalculateDistanceIcon';
import {
  setMapMode,
  setFirstDestination,
  setSecondDestination
} from '../../../../../redux/slices/mapSlice';

interface MCalculateDistanceProps {
  isSahel?: boolean;
}

const MCalculateDistance = ({ isSahel }: MCalculateDistanceProps) => {
  const { asPath } = useRouter();

  const { t } = useTranslation('map');

  const dispatch = useDispatch();

  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );

  const closeCalculateDistance = () => {
    dispatch(setMapMode(MapMode.SEARCH));
    dispatch(setFirstDestination(null));
    dispatch(setSecondDestination(null));
    logEvent.click('mapcalculate_distance', getPageLocation(asPath), 'map', {
      sahel_distance_checked: false
    });
  };

  return (
    <>
      <InputsContainer>
        <CalculateDistanceInput destination="a" isSahel={isSahel} />
        <CalculateDistanceInput destination="b" isSahel={isSahel} />
      </InputsContainer>

      {!(firstDestination && secondDestination) && (
        <Button className="button" onClick={closeCalculateDistance}>
          <CalculateDistanceIcon stroke="#fff" />

          <span>{t('calculate_distance')}</span>

          <CircleCloseIcon />
        </Button>
      )}

      {firstDestination && secondDestination && <MDistanceResult />}
    </>
  );
};

const InputsContainer = styled.div`
  max-width: 100%;
  position: fixed;
  top: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 4px;
  z-index: 9999;
`;

const Button = styled.button`
  position: fixed;
  bottom: 32px;
  height: 40px;
  left: 50%;
  transform: translateX(-50%);
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  gap: 4px;
  border-radius: 360px;
  background: #015c9a;
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border: none;

  span {
    color: #fff;
    font-size: 14px;
    font-family: materialBold;
    white-space: nowrap;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export default MCalculateDistance;
